import { Link } from 'react-router-dom';
import type { UserAccountStatus } from '../../api/apiSchemas';
import { useIdentities, useSession } from '../../auth/authQueries';
import { Avatar } from '../../components/account/Avatar';
import { Card } from '../../components/ui';
import { ROUTES } from '../../lib/routes';
import '../../components/account/account.css';

const STATUS_LABEL: Record<UserAccountStatus, string> = {
  ACTIVE: 'Đang hoạt động',
  PENDING_ONBOARDING: 'Chưa hoàn tất',
  SUSPENDED: 'Tạm khóa',
  PENDING_REVIEW: 'Đang chờ xét duyệt',
};

export default function AccountPage() {
  const session = useSession();
  const identities = useIdentities(true);

  if (!session.data?.authenticated) return null;
  const user = session.data.user;
  const connectedCount = identities.data?.identities.length ?? null;

  return (
    <div className="stack">
      <h1>Tổng quan tài khoản</h1>

      <Card>
        <div className="account-head">
          <Avatar displayName={user.displayName} pictureUrl={user.pictureUrl} />
          <div>
            <strong style={{ fontSize: '1.1rem' }}>{user.displayName ?? 'Người dùng'}</strong>
            <div className="muted">{user.email ?? 'Chưa có email'}</div>
          </div>
        </div>
      </Card>

      <Card>
        <div className="definition">
          <div className="definition__row">
            <span className="definition__label">Trạng thái</span>
            <span>{STATUS_LABEL[user.status]}</span>
          </div>
          <div className="definition__row">
            <span className="definition__label">Phương thức đăng nhập</span>
            <span>{connectedCount === null ? '…' : `${connectedCount} đã liên kết`}</span>
          </div>
        </div>
      </Card>

      <Card>
        <nav className="stack" aria-label="Quản lý tài khoản">
          <Link to={ROUTES.profile}>Hồ sơ cá nhân</Link>
          <Link to={ROUTES.connections}>Phương thức đăng nhập</Link>
          <Link to={ROUTES.security}>Bảo mật &amp; phiên đăng nhập</Link>
        </nav>
      </Card>
    </div>
  );
}
